import React from "react";
import './NotFound.scss';

const NotFound = () => {

  return (
    <>
       <div id="error-page">
         <div className="content">
            <h2 className="header" data-text="404">
               404
            </h2>
            <h4 data-text="Opps! Page not found">
              Oops! Page not found
            </h4>
            <p>
               The page you are looking for is not found or never existed.
            </p>
            <div className="btns">
            </div>
         </div>
      </div>
    </>
  );
};
export default NotFound;
